import { NumberInput, NumberInputProps } from '@mews-commander/ui';
import { ControllerProps, useControllerHandler } from '@mews/framework';

export type UncontrolledNumberInputFieldProps = Omit<NumberInputProps, 'value' | 'error' | 'onBlur'> &
    ControllerProps<NumberInputProps['value']>;

/**
 * @deprecated This component is deprecated and will be removed in future releases.
 * Please migrate to `NumberInputField` instead.
 *
 * This version is uncontrolled and does not integrate with React Hook Form.
 */
export const UncontrolledNumberInputField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: UncontrolledNumberInputFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });

    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: (newValue?: number) => handleChange(null, newValue),
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <NumberInput {...props} />;
};
